var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.37015 4.89955L2.53906 9.94476C2.45891 10.0276 2.3953 10.1262 2.35189 10.2348C2.30848 10.3435 2.28613 10.46 2.28613 10.5776C2.28613 10.6953 2.30848 10.8118 2.35189 10.9204C2.3953 11.0291 2.45891 11.1277 2.53906 11.2105C2.69926 11.3765 2.91598 11.4697 3.14188 11.4697C3.36777 11.4697 3.58449 11.3765 3.74469 11.2105L8.02 6.79819L12.2526 11.2105C12.4128 11.3765 12.6295 11.4697 12.8554 11.4697C13.0813 11.4697 13.298 11.3765 13.4582 11.2105C13.539 11.128 13.6033 11.0295 13.6473 10.9209C13.6913 10.8122 13.7142 10.6956 13.7147 10.5776C13.7142 10.4597 13.6913 10.343 13.6473 10.2344C13.6033 10.1258 13.539 10.0273 13.4582 9.94476L8.62709 4.89955C8.54702 4.80907 8.44984 4.73686 8.34168 4.68747C8.23351 4.63808 8.11671 4.61258 7.99862 4.61258C7.88054 4.61258 7.76373 4.63808 7.65557 4.68747C7.5474 4.73686 7.45022 4.80907 7.37015 4.89955Z",
    fill: "#232360"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHide);
export default __webpack_public_path__ + "static/media/iconsHide.fa0beaf70fabb686ecee211d2c8c4194.svg";
export { ForwardRef as ReactComponent };